import { StandardFenceApi } from '@wiz-api/personnel-position'
import { ModelSceneApi } from '@wiz-api/scene-management'
import {
  map,
  forEach,
  isNil,
  pick,
  cloneDeep,
  get,
  find,
  concat,
  fromPairs,
  isEmpty,
  findIndex,
  filter,
  isArray,
} from 'lodash'

const fenceApi = new StandardFenceApi()
const modelSceneApi = new ModelSceneApi()
let cloudRender
/** ************************************************ 电子围栏列表 **************************************** */
// 电子围栏绘制实例列表
let electronicFenceInstance = []
// 电子围栏列表
let electronicFenceList = []
// 电子围栏图标id列表
let electronicIconList = []
let sceneOptions = {
  isEnableGis: false,
  latitude: 0,
  longitude: 0,
  name: '',
  id: '',
  folderId: '',
  jsonData: '',
}
let drawHandler
let player

// 获取场景详情
const getSceneDetail = async (id) => {
  const [err, res] = await modelSceneApi.get(id)
  let options = null
  if (!err && !isNil(res)) {
    options = pick(res, ['isEnableGis', 'latitude', 'longitude', 'name', 'id', 'folderId'])
  }
  const [jsonErr, jsonRes] = await modelSceneApi.getModelSecenRelatedJson({ id })
  if (!jsonErr) {
    options.jsonData = jsonRes
  }
  sceneOptions = cloneDeep(options)
}

// 初始化数据
const initFenceData = () => {
  electronicFenceInstance = []
  electronicFenceList = []
  electronicIconList = []
  drawHandler = null
  sceneOptions = {
    isEnableGis: false,
    latitude: 0,
    longitude: 0,
    name: '',
    id: '',
    folderId: '',
    jsonData: '',
  }
}
// 生成UUID
const getUUID = () => {
  const tempUrl = URL.createObjectURL(new Blob())
  const uuid = tempUrl.toString()
  URL.revokeObjectURL(tempUrl)
  return uuid.substring(uuid.lastIndexOf('/') + 1)
}
// 打开电子围栏详情
const openFenceDetail = (fenceId) => {
  if (!fenceId) {
    return
  }
  const openEvent = new CustomEvent('openComponent', {
    detail: {
      toCom: {
        code: 'ElectronicFenceInfo',
        origin: 'tag',
        name: '电子围栏详情',
        originTagName: 'ElectronicFence',
      },
      type: 'tags',
      props: {
        fenceId,
      },
    },
  })
  window.dispatchEvent(openEvent)
}

// 获取电子围栏列表
const getFenceList = async (sceneId) => {
  const [err, res] = await fenceApi.getList({
    modelId: sceneId,
    dataSource: 1,
    maxResultCount: 999,
  })
  if (!err && res) {
    forEach(res.items, (item) => {
      if (isNil(item.switch) && !isNil(item._switch)) {
        item.switch = item._switch
      }
    })
    return res.items
  }
  return []
}

// 创建电子围栏
const drawElectronicFence = async (player, fenceDetail) => {
  if (!player.Native) {
    return
  }
  const pos = map(fenceDetail.points, (item) => {
    return [item.x, item.y, item.z]
  })
  const styleOptions = {
    type: 'fence',
    style: 'deafult',
  }
  const baseOptions = {
    name: 'newFence',
    pos,
    height: fenceDetail.height || 2,
    id: getUUID(),
    editMode: false,
  }
  if (sceneOptions.isEnableGis) {
    let realH = await player.Native.GisPlatform.queryDEM([
      [sceneOptions.longitude, sceneOptions.latitude],
    ])
    realH = isArray(realH) ? 0 : realH
    baseOptions.llh = [sceneOptions.longitude, sceneOptions.latitude, realH]
  }
  const fenceModelObject = await cloudRender.ElectoronicRail.createByPosition(
    baseOptions,
    styleOptions
  )
  await new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, 500)
  })
  const aabb = await player.Native.Node.getProperty(fenceModelObject.data.fenceObject, ['aabb'])
  const centerPos = [
    (aabb.aabb[1][0] + aabb.aabb[0][0]) / 2,
    (aabb.aabb[1][1] + aabb.aabb[0][1]) / 2,
    aabb.aabb[1][2],
  ]
  if (!isEmpty(centerPos)) {
    // 每个图标的id就是当前围栏的id
    const options = {
      id: fenceDetail.id,
      pos: [centerPos[0], centerPos[1], centerPos[2]], // 定位点，世界坐标，三维向量，默认值为[0, 0, 0]
      visible: true, // 显示隐藏状态，boolean类型，默认值为true
      backgroundUrl: 'data://../apps/SAAS/icon/fence-bg.png',
      nodeOffset: [0, 0],
      imgSize: [35, 35],
      markPosType: 0,
    }
    const iconRes = await cloudRender.Marker.createByPicture(options)
    if (iconRes.status) {
      electronicIconList = concat(electronicIconList, iconRes.data)
    }
  }
  // 缓存围栏绑定的数据id
  electronicFenceInstance.push({ fenceId: fenceDetail.id, fenceModelObject })
}

// 标签事件
const markerClick = (e) => {
  // 左键点击并且有id
  if (e.type === 1 && !isEmpty(e.markerId)) {
    const fence = find(electronicIconList, (item) => {
      return item === e.markerId
    })
    if (!isEmpty(fence)) {
      moveToFence(e.markerId)
      // 移动到视角
      openFenceDetail(e.markerId)
    }
  }
}

// 点击定位到围栏位置
const moveToFence = async (fenceId) => {
  const fenceInfo = find(electronicFenceList, ['id', fenceId])
  // 有保存视角就移到保存的视角
  if (fenceInfo && fenceInfo.playerVisualAngle) {
    await cloudRender.Camera.moveCamera('CameraParam', JSON.parse(fenceInfo.playerVisualAngle))
  } else if (fenceInfo) {
    const fenceModelObject = get(
      find(electronicFenceInstance, ['fenceId', fenceId]),
      'fenceModelObject'
    )
    // 没有保存视角，那么默认移到围栏的视角
    const aabb = await player.Native.EFence.getProperty(fenceModelObject.data.fenceObject, ['aabb'])
    await cloudRender.Camera.moveCamera('Aabb', [aabb.aabb[0], aabb.aabb[1]])
  }
}

// 电子围栏点击事件
const eventSelected = (e) => {
  if (e.node) {
    const fenceInfo = find(electronicFenceInstance, ['fenceModelObject.data.fenceObject', e.node])
    // 不存在选中电子围栏
    if (!fenceInfo) {
      return
    }
    openFenceDetail(get(fenceInfo, 'fenceId'))
  }
}

// 创建电子围栏
const create = async (propPlayer, sourceId, propCloudRender, fenceIdList) => {
  player = propPlayer
  if (!player.Native) {
    return
  }
  // 初始化数据
  initFenceData()
  await getSceneDetail(sourceId)
  cloudRender = propCloudRender
  // 监听标签点击事件
  cloudRender.Dispatch.on('Marker', markerClick)
  // // 监听电子围栏点击事件
  player.Native.Tools.EventBrowseLClick.connect(eventSelected)
  drawHandler = new Promise(async (resolve) => {
    // 获取电子围栏列表数据
    electronicFenceList = await getFenceList(sourceId)
    electronicFenceList = filter(electronicFenceList, (item) => {
      return item.switch || item._switch
    })
    await Promise.all(
      map(electronicFenceList, (item) => {
        return drawElectronicFence(player, item)
      })
    )
    if (!isNil(fenceIdList)) {
      await toggleDisplay(player, false, fenceIdList)
    }
    resolve()
  })
}

// 销毁电子围栏
const destroy = async (player) => {
  if (!player.Native) {
    return
  }
  await drawHandler
  if (!get(cloudRender, 'Marker')) return
  // 销毁电子围栏绘制
  cloudRender.ElectoronicRail.destroy(map(electronicFenceInstance, 'fenceModelObject.data.id'))
  cloudRender.Marker.destroyMarker(electronicIconList)
  // 取消标签的事件监听
  cloudRender.Dispatch.off('Marker', markerClick)
  // // 取消电子围栏事件监听
  player.Native.Tools.EventBrowseLClick.disconnect(eventSelected)
}

// 切换标签围栏显示隐藏
const toggleDisplay = async (player, type, fenceIdList) => {
  await drawHandler
  if (type) {
    forEach(electronicFenceInstance, async (item) => {
      await player.Native.EFence.setProperty(item.fenceModelObject?.data?.fenceObject, {
        visible: true,
      })
    })
    // 如果是展示，则全部展示
    cloudRender.Marker.updateByPicture(
      map(electronicIconList, (i) => {
        return {
          id: i,
          visible: true,
        }
      })
    )
  } else {
    // 设置围栏的显隐
    forEach(electronicFenceInstance, async (item) => {
      // 不再楼层中的隐藏
      if (
        !some(fenceIdList, (el) => {
          return el === item.fenceId
        })
      ) {
        await player.Native.EFence.setProperty(item.fenceModelObject?.data?.fenceObject, {
          visible: false,
        })
      } else {
        // 在楼层中的显示
        await player.Native.EFence.setProperty(item.fenceModelObject?.data?.fenceObject, {
          visible: true,
        })
      }
    })
    // 如果是隐藏
    // 隐藏不在楼层范围内的围栏标签
    // 显示在楼层范围内的围栏标签
    forEach(electronicIconList, (item) => {
      if (
        !some(fenceIdList, (el) => {
          return el === item
        })
      ) {
        cloudRender.Marker.updateByPicture({ id: item, visible: false })
      } else {
        cloudRender.Marker.updateByPicture({ id: item, visible: true })
      }
    })
  }
}

const hidden = async (player, sourceId, cloudRender, fenceIdList) => {
  await toggleDisplay(player, false, fenceIdList)
}
const display = async (player) => {
  await toggleDisplay(player, true)
}
export default { create, destroy, hidden, display }
